import React, { useEffect, useMemo, useState } from 'react';

const CSS = `
.bk-hero { border-radius: 14px; padding: 16px 18px; margin-bottom: 16px; background: linear-gradient(120deg, rgba(180,120,60,0.55), rgba(124,77,255,0.32) 65%, rgba(0,163,163,0.24)); }
.bk-hero h2 { margin: 0; font-size: 24px; font-weight: 800; }
.bk-hero p { margin: 4px 0 0; font-size: 13px; color: rgba(255,255,255,0.85); }
.bk-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(118px, 1fr)); gap: 16px 12px; }
.bk-card { background: none; border: none; padding: 0; color: var(--text); text-align: left; cursor: pointer; }
.bk-cover { position: relative; aspect-ratio: 2/3; border-radius: 6px; overflow: hidden; background: linear-gradient(150deg, #3a2f28, #17141c); box-shadow: 3px 5px 14px rgba(0,0,0,0.55); }
.bk-cover img { width: 100%; height: 100%; object-fit: cover; display: block; }
.bk-plain { position: absolute; inset: 0; display: flex; flex-direction: column; justify-content: center; padding: 10px; font-weight: 700; font-size: 14px; line-height: 1.25; }
.bk-plain small { margin-top: 6px; font-weight: 400; font-size: 11px; color: var(--text2); }
.bk-bar { position: absolute; left: 0; right: 0; bottom: 0; height: 4px; background: rgba(0,0,0,0.5); }
.bk-bar i { display: block; height: 100%; background: var(--accent); }
.bk-title { margin-top: 7px; font-size: 13px; font-weight: 600; line-height: 1.25; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.bk-author { margin-top: 2px; font-size: 11px; color: var(--text2); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
`;

function Book({ b }) {
  const [broken, setBroken] = useState(false);
  const open = () => {
    window.location.href = `/reader.html?id=${encodeURIComponent(b.id)}&title=${encodeURIComponent(b.title)}&author=${encodeURIComponent(b.author || '')}`;
  };
  return (
    <button type="button" className="bk-card" onClick={open}>
      <div className="bk-cover">
        {b.cover && !broken ? <img src={b.cover} alt="" loading="lazy" onError={() => setBroken(true)} /> : <div className="bk-plain">{b.title}<small>{b.author}</small></div>}
        {b.percent > 0 ? <div className="bk-bar"><i style={{ width: `${Math.min(100, Math.round(b.percent * 100))}%` }} /></div> : null}
      </div>
      <div className="bk-title">{b.title}</div>
      <div className="bk-author">{b.author}{b.percent > 0 ? ` · ${Math.round(b.percent * 100)}%` : ''}</div>
    </button>
  );
}

/** Your ebooks, for phones and tablets. The reader itself is /reader.html. */
export default function BooksView() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState('');
  const [err, setErr] = useState('');
  useEffect(() => {
    fetch('/api/ebooks', { credentials: 'include' })
      .then((r) => r.json())
      .then((d) => setItems(d.items || []))
      .catch(() => {
        setItems([]);
        setErr('Could not load your books.');
      });
  }, []);
  const shown = useMemo(() => {
    const s = q.trim().toLowerCase();
    const list = items || [];
    return s ? list.filter((b) => `${b.title} ${b.author}`.toLowerCase().includes(s)) : list;
  }, [items, q]);
  const reading = shown.filter((b) => b.percent > 0).sort((a, b) => (b.at || 0) - (a.at || 0));
  const rest = shown.filter((b) => !(b.percent > 0));
  return (
    <div style={{ maxWidth: 1000 }}>
      <style>{CSS}</style>
      <div className="bk-hero">
        <h2>Books</h2>
        <p>Pick up where you left off, on any phone or tablet.</p>
      </div>
      <input placeholder="Search your books" value={q} onChange={(e) => setQ(e.target.value)} style={{ width: '100%', maxWidth: 420, padding: '10px 14px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg3)', color: 'var(--text)', fontSize: 14, marginBottom: 16, boxSizing: 'border-box' }} />
      {err ? <div style={{ color: '#ff8a8a', marginBottom: 12 }}>{err}</div> : null}
      {!items ? <div style={{ color: 'var(--text2)' }}>Loading books…</div> : null}
      {items && !shown.length ? <div style={{ color: 'var(--text2)' }}>{q ? 'No books match that.' : 'No ebooks yet. Request one in Discover.'}</div> : null}
      {reading.length ? (
        <>
          <h3 style={{ fontSize: 15, fontWeight: 700, margin: '0 0 10px' }}>Keep reading</h3>
          <div className="bk-grid" style={{ marginBottom: 22 }}>{reading.map((b) => <Book key={b.id} b={b} />)}</div>
        </>
      ) : null}
      {rest.length ? (
        <>
          {reading.length ? <h3 style={{ fontSize: 15, fontWeight: 700, margin: '0 0 10px' }}>Your library</h3> : null}
          <div className="bk-grid">{rest.map((b) => <Book key={b.id} b={b} />)}</div>
        </>
      ) : null}
    </div>
  );
}
